import React, { useMemo, useState, useEffect } from 'react'
import { Row, Col, Form, Button, Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Card from '../../../components/Card'

// img
// import facebook from '../../../assets/images/brands/fb.svg'
// import google from '../../../assets/images/brands/gm.svg'
// import instagram from '../../../assets/images/brands/im.svg'
// import linkedin from '../../../assets/images/brands/li.svg'
import auth1 from '../../../assets/images/auth/01.png'
import Logo from '../../../components/partials/components/logo'
import UserService from '../../../services/user/UserService'
import SweetAlert from 'react-bootstrap-sweetalert'
// import logoKkp from '../../../assets/images/logo-kkp.png'
// import { FaChevronRight } from 'react-icons/fa'
import CaptchaCanvas from '../../../components/CaptchaCanvas'

import ForgotPasswordModal from '../Password/ForgotPassword'

const SignIn = () => {
   let history = useNavigate()
   const [username, setUsername] = useState('')
   const [password, setPassword] = useState('')
   let userService = useMemo(() => new UserService(), [])

   const [showLoginSuccess, setShowLoginSuccess] = useState(false)
   const [showLoginFailed, setShowLoginFailed] = useState(false)
   const [showLoginNeedUpdate, setShowLoginNeedUpdate] = useState(false)
   const [loading, setLoading] = useState(false)
   const [token, setToken] = useState('')
   const [role, setRole] = useState('')
   const [kdUnit, setKdUnit] = useState('')
   const [statusUser, setStatusUser] = useState('')
   const [kodeTrader, setKodeTrader] = useState('')
   const [expired, setExpired] = useState('')
   const [nama, setNama] = useState('')
   const [userId, setUserId] = useState('')
   const [showForgotModal, setShowForgotModal] = useState(false);
   const [captchaText, setCaptchaText] = useState("");
   const [captchaInput, setCaptchaInput] = useState("");
   const [showCaptchaError, setShowCaptchaError] = useState(false);

      useEffect(() => {
         generateCaptcha(); 
      }, [])
         
     const generateCaptcha = () => {
       const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
       const text = Array.from({ length: 5 }, () => chars[Math.floor(Math.random() * chars.length)]).join("");
       setCaptchaText(text);
       setCaptchaInput("");
     };
   const onChangeUsername = e => {
      setUsername(e.target.value)
   }

   const onChangePassword = e => {
      setPassword(e.target.value)
   }

   const handleClickLogin = async () => {
      setLoading(true)
      if (captchaInput.toUpperCase() !== captchaText.toUpperCase()) {
         // alert("Captcha salah. Silakan coba lagi.");
         setShowCaptchaError(true);
         generateCaptcha();
         setCaptchaInput("");
         setLoading(false);
         return;
      }
      try {
         const response = await userService.login(username, password)
         if (response.data.statusCode === 200) {
            setToken(response.data.token)
            setRole(response.data.role)
            setKdUnit(response.data.kdUnit)
            setStatusUser(response.data.statusUser)
            setKodeTrader(response.data.kodeTrader)
            setExpired(response.data.expirationTime)
            setNama(response.data.nama)
            setUserId(response.data.userId)
            setShowLoginSuccess(true)
            // localStorage.setItem("token", response.data.token)
            // history('/dashboard')
         
         } else if (response.data.statusCode === 500) {
            if (response.data.statusUser === '0') {
               setShowLoginNeedUpdate(true)
            } else {
               setShowLoginFailed(true)
               generateCaptcha();
            }
         } else {
            setShowLoginFailed(true)
            generateCaptcha();
         }
      } catch (error) {
         // console.log(error)
         setShowLoginFailed(true)
         generateCaptcha();
      }
      setLoading(false)
   }

   const handleClickLoginSuccess = () => {
      const expiryTime = new Date().getTime() + parseInt(expired)
      localStorage.setItem("token", token)
      localStorage.setItem("role", role)
      localStorage.setItem("kdUnit", kdUnit)
      localStorage.setItem("kodeTrader", kodeTrader)
      localStorage.setItem("nama", nama)
      localStorage.setItem("username", username)
      localStorage.setItem("expired", expiryTime)
      localStorage.setItem("userId", userId)
      history('/dashboard')
   }

   const handleClickLoginFailed = () => {
      setShowLoginFailed(false)
      setLoading(false)
      generateCaptcha();
   }

   const handleClickUpdatePassword = () => {
      setShowLoginNeedUpdate(false)
      setLoading(false)
      localStorage.setItem("username", username)
      localStorage.setItem("statusUser", statusUser)
      history('/update-password')
   }

   const handleClickCancel = () => {
      setShowLoginNeedUpdate(false)
      setLoading(false)
   }

   // const handleClickPpk = () => {
   //    window.open('https://siapmutu.kkp.go.id/ppk', '_blank')
   // }

   const handleClickRegister = () => {
      history('/registrasi')
   }
   const handleClickHome = () => {
      history('/')
   
   }

   return (
      <>
         <section className="login-content">
            <Row className="m-0 align-items-center bg-white vh-100">
               <Col md="6" style={{ position: 'relative',  }}>
                     <div className="d-flex justify-content-start p-3">
                        <Button variant="warning" className="btn-hover-expand" onClick={handleClickHome} style={{zIndex: 10,}}>
                        ⬅ <span>Landing Page</span>
                        </Button>
                     </div>                
                  <Row className="justify-content-center">
                        <Col md="10">
                         <Card className="card-transparent shadow-none d-flex justify-content-center mb-0 auth-card">                     
                           <Card.Body>
                              <Logo /> 
                              <h2 className="mt-5 mb-2 text-center">SIAPMUTU</h2>   
                              <p className="mb-2 text-center">Sistem Informasi Aplikasi Pelayanan Mutu</p>
                              <Form>
                                 <Row>
                                    <Col lg="12">
                                       <Form.Group className="form-group">
                                          <Form.Label htmlFor="username" className="">Username</Form.Label>
                                          <Form.Control type="username" className="" id="username" aria-describedby="username" placeholder=" " defaultValue={username} onChange={onChangeUsername} />
                                       </Form.Group >
                                    </Col>
                                    <Col lg="12" className="">
                                       <Form.Group className="form-group">
                                          <Form.Label htmlFor="password" className="">Password</Form.Label>
                                          <Form.Control type="password" className="" id="password" aria-describedby="password" placeholder=" " defaultValue={password} onChange={onChangePassword} onKeyDown={(event) => {if(event.key === 'Enter'){handleClickLogin()}}} />
                                       </Form.Group>
                                    </Col>
                                    <Col>
                                    <div className="mb-3">
                                       <div className="d-flex align-items-center">
                                          <div className="me-3">
                                          <CaptchaCanvas text={captchaText} />
                                          </div>
                                         <Button className="d-flex justify-content-center align-items-center me-3" variant="primary" style={{ maxWidth: '50px', height: '30px' }}onClick={generateCaptcha}  >🔁</Button>
                                          <input
                                             type="text"
                                             className="form-control me-2 lg-4"
                                             placeholder="Ketik ulang teks disamping"
                                             value={captchaInput}
                                             onChange={(e) => setCaptchaInput(e.target.value)}
                                             onKeyDown={(event) => {if(event.key === 'Enter'){handleClickLogin()}}}
                                             required
                                             style={{ maxWidth: '320px' }}
                                             />
                                       </div>
                                    </div>
                                    </Col>
                                 </Row>
                                 <div className="d-flex justify-content-center">
                                    <Button onClick={() => handleClickLogin()} onKeyDown={(event) => {if(event.key === 'Enter'){handleClickLogin()}}} type="button" variant="btn btn-primary" disabled={loading}>{loading && <Spinner />} Login</Button>&nbsp;&nbsp;
                                    <Button onClick={() => handleClickRegister()} type="button" variant="btn btn-secondary" >Register</Button>
                                    
                                 </div>
                                 <a className="nav-link text-center my-3" onClick={() => setShowForgotModal(true)} type="button" >Lupa Password?</a>
                                 <p className="text-center my-3">v 1.0.2 <br/> 2025.11.01-16.00</p>
                              </Form>
                           </Card.Body>
                        </Card>
                     </Col>
                  </Row>
                  <div className="sign-bg">
                     <svg width="280" height="230" viewBox="0 0 431 398" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.05">
                           <rect x="-157.085" y="193.773" width="543" height="77.5714" rx="38.7857" transform="rotate(-45 -157.085 193.773)" fill="#3B8AFF" />
                           <rect x="7.46875" y="358.327" width="543" height="77.5714" rx="38.7857" transform="rotate(-45 7.46875 358.327)" fill="#3B8AFF" />
                           <rect x="61.9355" y="138.545" width="310.286" height="77.5714" rx="38.7857" transform="rotate(45 61.9355 138.545)" fill="#3B8AFF" />
                           <rect x="62.3154" y="-190.173" width="543" height="77.5714" rx="38.7857" transform="rotate(45 62.3154 -190.173)" fill="#3B8AFF" />
                        </g>
                     </svg>
                  </div>
               </Col>
               <Col md="6" className="d-md-block d-none bg-primary p-0 mt-n1 vh-100 overflow-hidden">
                  <Row className="justify-content-center conatiner-fluid content-inner mt-n5"
                     style={{
                        backgroundImage: `url(${auth1})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        minHeight: '130vh' // optional, if you want the row to cover the viewport height
                     }}
                  >
                     {/* <Col md="7">
                        <Card className="card-transparent shadow-none d-flex mb-0 auth-card">
                           <Card.Body>
                              <Row className="m-0 align-items-center bg-white d-flex">
                                 <Col md="8" className="d-flex justify-content-center align-items-center">
                                    <Image src={logoKkp} width={100} className='mx-5' />
                                    <div style={{ fontSize: '32px', fontWeight: 'bold' }}>
                                       <div style={{ textShadow: '1px 1px 0px #999' }}>
                                          <span style={{ color: '#164e7d' }}>
                                             Sister<span style={{ color: '#ff6600' }}>Karoline</span>
                                          </span>
                                       </div>
                                       <div style={{ fontSize: '17px', color: '#343b42', textShadow: '1px 1px 0px #ccc' }}>
                                          PPKOnline
                                       </div>
                                    </div>
                                 </Col>
                              </Row>
                              <Row>
                                 <p className="mb-2 text-center">Klik tombol untuk menuju PPK Online</p>
                              </Row>
                              <Row>
                                 <Button type="button" variant="btn btn-success" onClick={() => handleClickPpk()}><FaChevronRight />{' '}PPK Online</Button>
                              </Row>
                           </Card.Body>
                        </Card>
                     </Col> */}
                  </Row>
                  {/* <Image src={auth1} className="Image-fluid gradient-main animated-scaleX" alt="images" /> */}
               </Col>
            </Row>

          <ForgotPasswordModal
            show={showForgotModal}
            onClose={() => setShowForgotModal(false)}
            />
         </section>
         {
            showLoginSuccess &&
            <SweetAlert
               title="Login Success"
               success
               onConfirm={handleClickLoginSuccess}
               btnSize="sm"
               timeout={2000}
            />
         }
         {
            showLoginFailed &&
            <SweetAlert
               title="Login Gagal"
               danger
               onConfirm={handleClickLoginFailed}
               btnSize="sm"
            >User/Password Salah</SweetAlert>
         }
         {showCaptchaError && (
            <SweetAlert
               danger
               title="Captcha Salah"
               onConfirm={() => setShowCaptchaError(false)}
               btnSize="sm"
            >
               Teks captcha tidak cocok. Silakan coba lagi.
            </SweetAlert>
            )}
         {
            showLoginNeedUpdate &&
            <SweetAlert
               warning
               showCancel
               confirmBtnText="Update Password"
               confirmBtnBsStyle="warning"
               onConfirm={handleClickUpdatePassword}
               onCancel={handleClickCancel}
               btnSize="sm"
            >User Ditemukan Silakan Update Password terlebih dahulu</SweetAlert>
         }
      </>
   )
}

export default SignIn
